import { ValueOfKey } from '../../../utils-types';

/** config for names and orders of columns */
export const COACH_LIST_COLUMN = {
  NAME: 'NAME',
  ENTITY: 'ENTITY',
  STATE: 'STATE',
  CITY: 'CITY',
  SETUP_COMMISSION: 'SETUP_COMMISSION',
  RENEW_COMMISSION: 'RENEW_COMMISSION',
  COACH_DESIGNATION: 'COACH_DESIGNATION',
  STATUS: 'STATUS',
  EXTRA_INFO: 'EXTRA_INFO',
} as const;

export type CoachListColumn = ValueOfKey<typeof COACH_LIST_COLUMN>;

export type ShowColumnsConfig = Record<CoachListColumn, boolean>;

export const COLUMN_WIDTHS: Record<CoachListColumn, string> = {
  NAME: '1.25fr',
  ENTITY: '1fr',
  STATE: '1fr',
  CITY: '1fr',
  SETUP_COMMISSION: '1fr',
  RENEW_COMMISSION: '1fr',
  COACH_DESIGNATION: '1fr',
  STATUS: '1fr',
  EXTRA_INFO: 'auto',
};

export const COACH_LIST_MODE = {
  NUTRITION: 'NUTRITION',
  SCAN_IQ: 'SCAN_IQ',
} as const;

export type CoachListMode = ValueOfKey<typeof COACH_LIST_MODE>;
